// Ian - 2026-10-19 - Country suggestion pop-up (replaces Shopify's retired Geolocation app).
// Asks Shopify which country the visitor is in (/browsing_context_suggestions.json, the
// same lookup the Geolocation app used) and, if it's a country Eribe sells to and isn't the
// one they're shopping in, offers to switch. Never redirects on its own: switching only
// happens when the visitor clicks, through Shopify's own localization form, which Global-e
// reads. Not shown to search bots, to visitors who came in on a ?country= link, or to anyone
// who has already said no (remembered for 90 days). If the lookup ever stops answering,
// the pop-up simply doesn't appear and the header switcher carries on as normal.
// Testing: add ?country_suggest_test=LV to any URL to pretend the visitor is in Latvia.
(function () {
  var KEY = 'ian_country_suggest';
  var REMEMBER_DAYS = 90;
  var BOTS = /bot|crawl|spider|slurp|googlebot|bingbot|yandex|baidu|duckduck|facebookexternalhit|lighthouse|chrome-lighthouse|pagespeed|gtmetrix|headless|ahrefs|semrush|screaming frog|petalbot|applebot|gptbot|oai-searchbot|chatgpt|perplexity|claudebot|anthropic|google-inspectiontool|storebot/i;

  if (BOTS.test(navigator.userAgent || '') || navigator.webdriver) return;

  var dataEl = document.getElementById('ian-country-suggest-data');
  var form = document.getElementById('IanCountrySuggestForm');
  if (!dataEl || !form) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
  var testCountry = params ? (params.get('country_suggest_test') || '').toUpperCase() : '';

  // A ?country= deep link is an explicit choice, so leave it alone.
  if (!testCountry && params && params.get('country')) return;

  function readSaved() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (saved && saved.ts && Date.now() - saved.ts < REMEMBER_DAYS * 86400000) return saved;
    } catch (e) {}
    return null;
  }

  function save(choice) {
    try { window.localStorage.setItem(KEY, JSON.stringify({ choice: choice, ts: Date.now() })); } catch (e) {}
  }

  if (!testCountry && readSaved()) return;

  function detect() {
    if (testCountry) return Promise.resolve(testCountry);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var c = json && json.detected_values && json.detected_values.country;
        return c && c.handle ? String(c.handle).toUpperCase() : '';
      })
      .catch(function () { return ''; });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  // Liquid HTML-escapes country names ("Antigua &amp; Barbuda"); a textarea decodes without running anything.
  function decode(text) {
    var t = document.createElement('textarea');
    t.innerHTML = text;
    return t.value;
  }

  function show(code) {
    if (!data.countries[code]) return;
    var name = decode(data.countries[code]);

    var box = el('div', 'ian-country-suggest');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-labelledby', 'ian-country-suggest-title');

    var close = el('button', 'ian-country-suggest__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';

    // Currency is left out on purpose: most countries sit in GBP in Shopify, and Global-e
    // can show local prices on top, so naming one here could be wrong.
    var title = el('p', 'ian-country-suggest__title', 'Shopping from ' + name + '?');
    title.id = 'ian-country-suggest-title';

    var body = el('p', 'ian-country-suggest__text',
      'Switch to ' + name + ' to see the right prices and delivery options for your country.');

    var actions = el('div', 'ian-country-suggest__actions');
    var go = el('button', 'btn ian-country-suggest__go', 'Shop in ' + name);
    go.type = 'button';
    var stay = el('button', 'ian-country-suggest__stay', 'No thanks');
    stay.type = 'button';
    actions.appendChild(go);
    actions.appendChild(stay);

    box.appendChild(close);
    box.appendChild(title);
    box.appendChild(body);
    box.appendChild(actions);
    document.body.appendChild(box);

    function dismiss() {
      save('stay');
      box.setAttribute('data-closed', '');
      box.classList.remove('is-visible');
      document.body.classList.remove('ian-country-suggest-open');
      setTimeout(function () { box.remove(); }, 300);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') dismiss(); }

    close.addEventListener('click', dismiss);
    stay.addEventListener('click', dismiss);
    document.addEventListener('keydown', onKey);

    go.addEventListener('click', function () {
      save('switch');
      go.disabled = true;
      form.querySelector('input[name="country_code"]').value = code;
      form.submit();
    });

    return box;
  }

  // Shows as soon as the country is known. Shopify's cookie banner shares the bottom of the
  // screen, so while it's open the card sits directly above it rather than waiting for it.
  // Klaviyo's sign-up pop-up darkens the whole page, so the card steps aside while that's open.
  function isOpen(node) {
    if (!node) return false;
    var style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
  }

  function klaviyoOpen() {
    var forms = document.querySelectorAll('.needsclick[role="dialog"][aria-label$="Form"]');
    for (var i = 0; i < forms.length; i++) if (isOpen(forms[i])) return true;
    return false;
  }

  function placeAboveCookieBanner(box) {
    var banner = document.querySelector('#shopify-pc__banner .shopify-pc__banner__dialog') ||
      document.getElementById('shopify-pc__banner');
    if (isOpen(banner)) {
      var top = banner.getBoundingClientRect().top;
      box.style.bottom = Math.max(0, window.innerHeight - top) + 12 + 'px';
    } else {
      box.style.bottom = '';
    }
  }

  detect().then(function (code) {
    if (!code || code === data.current || !data.countries[code]) return;
    var box = show(code);
    if (!box) return;
    function update() {
      if (!box.isConnected || box.hasAttribute('data-closed')) { clearInterval(timer); return; }
      placeAboveCookieBanner(box);
      var clear = !klaviyoOpen();
      box.classList.toggle('is-visible', clear);
      document.body.classList.toggle('ian-country-suggest-open', clear);
    }
    var timer = setInterval(update, 300);
    requestAnimationFrame(update);
  });
})();
